import { lazy } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import Loadable from 'ui-component/Loadable';
import MinimalLayout from 'layout/MinimalLayout';
import UserLayout from 'layout/UserLayout';
import jwt from 'jwtservice/jwtService';

const UserLoginPage      = Loadable(lazy(() => import('views/user/UserLoginPage')));
const UserForgotPassword = Loadable(lazy(() => import('views/user/UserForgotPasswordPage')));
const UserResetPassword  = Loadable(lazy(() => import('views/user/UserResetPasswordPage')));
const UserDashboard      = Loadable(lazy(() => import('views/user/UserDashboard')));
const UserComplaints     = Loadable(lazy(() => import('views/user/UserComplaints')));
const UserProfile        = Loadable(lazy(() => import('views/user/UserProfile')));
const UserChangePassword = Loadable(lazy(() => import('views/user/UserChangePassword')));

const RequireUserAuth = () =>
    jwt.getUserIsLogin() ? <Outlet /> : <Navigate to="/user-login" replace />;

const RedirectIfUserAuth = ({ children }) =>
    jwt.getUserIsLogin() ? <Navigate to="/user/dashboard" replace /> : children;

const UserRoutes = [
    {
        path: '/',
        element: <MinimalLayout />,
        children: [
            { path: '/user-login',           element: <RedirectIfUserAuth><UserLoginPage /></RedirectIfUserAuth> },
            { path: '/user-forgot-password', element: <UserForgotPassword /> },
            { path: '/user-reset-password',  element: <UserResetPassword /> },
        ],
    },
    {
        path: '/user',
        element: <RequireUserAuth />,
        children: [
            {
                element: <UserLayout />,
                children: [
                    { path: 'dashboard',       element: <UserDashboard /> },
                    { path: 'complaints',      element: <UserComplaints /> },
                    { path: 'profile',         element: <UserProfile /> },
                    { path: 'change-password', element: <UserChangePassword /> },
                ],
            },
        ],
    },
];

export default UserRoutes;
